import styled from 'styled-components'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`

export const Arrow = styled(ArrowForwardIosIcon)``

export const TitleText = styled.p`
  font-size: 13px;
  color: #63a5c0;
`

export const TextCol = styled.div`
    display: flex;
    flex-direction: column;
`

interface ValueTextProps {
	description?: boolean
}

export const ValueText = styled.p<ValueTextProps>`
  font-size: ${props => props.description ? '12px' : '16px'};
  color: #224858;
  margin: 10px 0;
  white-space: pre-wrap;
`
